import { VegaCard, VegaFlex, VegaFont } from '@globalpayments/vega-react';
import { format } from 'date-fns';
import { getDate } from '../../configInfo/components/Functions';
import { log } from './Interfaces';

interface Props {
  log: log;
  delay: number;
  animate: boolean;
}

const Log: React.FC<Props> = ({ log, delay, animate }) => {
  const date = format(getDate(new Date(log.dateUTC)), 'MM/dd/yyyy, hh:mm:ssaaa');

  return (
    <div
      className={animate ? 'session-info-activity session-info-activity--animate' : 'session-info-activity'}
      style={animate ? { animationDelay: `${delay}ms` } : undefined}>
      <VegaCard padding="size-16" variant="border">
        <VegaFlex direction="col" gap="size-8">
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>Date: </strong>
            {date}
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>Lead Type: </strong>
            {log.leadType}
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>Lead Status Type: </strong>
            {log.leadStatusType}
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>Lead Status Text: </strong>
            {log.leadStatusText}
          </VegaFont>
        </VegaFlex>
      </VegaCard>
    </div>
  );
};

export default Log;
